import { STANDARD_DELIVERY_TYPE, deliveryIsFree } from '@/shared/delivery'
import { cloneObject } from '@/shared/clone'
import { addDaysToCurrentDate } from '@/shared/date'

export function setDepartments (state, departments) {
  state.departments = departments
}

export function setCities (state, cities) {
  state.cities = cities
}

export function setDeliveryTypes (state, deliveryTypes) {
  state.deliveryTypes = deliveryTypes
}

export function setShippingInfo (state, shippingInfo) {
  state.shippingInfo = shippingInfo
}

export function buildShippingInfo (state, { deliveryTypes, totalValue }) {
  let shippingInfo = cloneObject(deliveryTypes.find((deliveryType) => deliveryType.delivery_type === STANDARD_DELIVERY_TYPE))
  if (!shippingInfo) {
    shippingInfo = cloneObject(deliveryTypes[0])
  }

  if (deliveryIsFree(shippingInfo, totalValue)) {
    shippingInfo.cost = 0
  }

  shippingInfo.delivery_date = addDaysToCurrentDate(shippingInfo.delivery_days)

  state.shippingInfo = shippingInfo
}

export function setShippingInput (state, shippingInput) {
  state.shippingInput = shippingInput
}
